import bowser from 'bowser'
import AboutView from './views/about-view'
import $ from 'init/jquery'
import eventBus from 'init/event-bus'
import { user } from 'init/user'
import { cart } from 'init/cart'
import { wish } from 'init/wish'
import { settlement } from 'init/settlement'
import { pushToRegistry } from 'init/registry'

import { getCurrentOsVersions, getOperaMiniOrMobileOptions } from 'helpers/browser-detect-helper'
import { BodyView } from 'es6/views/body-view'
import { UserView } from 'es6/views/user-view'
import { OkoEvents } from 'es6/views/oko-events'
import { OverlayView } from 'es6/views/overlay-view'
import { FaderView } from 'es6/views/fader/fader-view'
import { MainWindow } from 'es6/views/main-window-view'
import { ToTopView } from 'es6/views/footer/to-top-view'
import { FooterView } from 'es6/views/footer/footer-view'
import { EcommerceEvents } from 'es6/views/ecommerce-events'
import { SearchBarView } from 'es6/views/search/search-bar-view'
import { ReduxDispatchesView } from 'es6/views/redux-dispatches-view'
import { CommonPopupsView } from 'es6/views/popups/common-popups-view'
import { OldBrowserPopupView } from 'es6/views/popups/old-browser-popup-view'
import { ChponkCommonView } from '../chponk/chponk-common-view'
import {
  createExecuteChannel,
  subscribeToCommands,
} from 'helpers/cqc-helper'
import {
  CQC_COMMAND_TYPES,
  CQC_ES6_CONTEXT,
} from 'es6/constants'

createExecuteChannel([CQC_COMMAND_TYPES.settlementUpdate], CQC_ES6_CONTEXT)
subscribeToCommands([CQC_COMMAND_TYPES.settlementUpdate])

const layout = $('.layout'),
  jsView = layout.data('jsview') || $('.main-content').data('jsview'),
  fader = new FaderView(),
  mainWindow = new MainWindow(),
  searchBarOptions = {
    el: $('#search-form').length ? $('#search-form') : $('#w0'),
    user: user,
  },
  bodyView = new BodyView({
    jsView: jsView,
    settlement: settlement,
    user: user,
    faderView: fader,
    cart: cart,
    autoRewritePageLinks: false,
  })

pushToRegistry(
  new ReduxDispatchesView({
    jsView,
    settlement,
  }),
  new UserView({
    settlement: settlement,
    user: user,
  }),
  new CommonPopupsView(),
  new OverlayView(),
  new FooterView({
    cart: cart,
    settlement: settlement,
    user: user,
  }),
  new ToTopView({
    mainWindow: mainWindow,
  }),
  new SearchBarView(searchBarOptions),
  bodyView,
  new ChponkCommonView({
    mainWindow: mainWindow,
    eventBus: eventBus,
  }),
  new OldBrowserPopupView({
    versions: getCurrentOsVersions(bowser),
    bowser: bowser,
    operaMiniOrMobileOptions: getOperaMiniOrMobileOptions(bowser, navigator),
    isPageSpeedTest: navigator.userAgent.includes('Google Page Speed'),
  }),
  new OkoEvents({
    wish: wish,
  }),
  new EcommerceEvents({
    cart: cart,
  }),
  new AboutView({
    el: 'main',
  })
)
